module.exports = __webpack_public_path__ + "static/media/flizz_turksih.3728478d.mp3";